/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 09:41:35
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-29 16:41:18
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/Components/CollectionInfo/index.tsx
 */
import { Input } from '@/src/components/Antd';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { SectionContent } from 'src/layout/EditorPageLayout/EditorCollapsePageLayout';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { EnumCollapseId } from '../../common';
import { getCollapse, onCollapseChange } from '../../slice/edit';
import css from './css.module.less';

const CollectionInfo = ({
  collectionNameOnChange,
  collectionName,
  onBlur,
  error,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionContent>
      <Row
        elements={[
          {
            child: !disabled ? (
              <ItemWrapper
                title={`${getI18n('productCollection.index.collectionName')}*`}
                rightPart={
                  <CountWords
                    count={(collectionName || '').length}
                    allCount={100}
                  />
                }>
                <Input
                  size='large'
                  maxLength={100}
                  onChange={(data) => collectionNameOnChange(data)}
                  value={collectionName}
                  onBlur={onBlur}
                  error={error}
                  help={
                    !collectionName
                      ? getI18n('productCollection.index.pleasefilltheform')
                      : getI18n(
                          'productCollection.index.productcollectionsamename',
                        )
                  }
                />
              </ItemWrapper>
            ) : (
              <div className={css.container}>
                <h3 className={css.title}>
                  {getI18n('productCollection.index.collectionName')}*
                </h3>
                <span className={css.text}> {collectionName}</span>
              </div>
            ),
          },
          {
            child: '',
          },
        ]}
      />
    </SectionContent>
  );
};
export default SectionHOC(CollectionInfo, {
  id: EnumCollapseId.CollectionInfo,
  title: getI18nFromGeneral('general.hOCTitle.productCollectionSetting'),
  getCollapse,
  onCollapseChange,
  cannotCollapse: true,
});
